import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const fileUrl = (path) => (path ? `${API}/files/${path}` : null);

const client = axios.create({ baseURL: API, withCredentials: true });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("psl_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const setToken = (t) => {
  if (t) localStorage.setItem("psl_token", t);
  else localStorage.removeItem("psl_token");
};

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export default client;
